<div #container class="container" [ngClass]="{edx_hidden:hitPreviewShown&&!hitPreviewHiding&&!hitPreviewShowing, hasfooter:hasFooter, hasheader:hasHeader, tablet:tablet, indialog:hasFootprint, oai:isAddin, ie_edge:ieEdge, dragover:!dragOverItem&&dragover, readonly:!!schema && schema.readOnly}" (click)="forceRender($event)">
  @if (hasHeader) {
    <div class="header" id="edx_mobile_list_header">
      <div>
        <div class="header-count">{{countInfo()}}</div>
        @if (!showHeaderSection() && showFilterIcon()) {
          <div class="toucharea right" (click)="filterClicked($event)" id="edx_hdr_icon_filter" [title]="this.localizer.getTranslation('TOOLTIP.FILTER')">
            <div class="icon filter" tabindex="0" (keydown.space)="filterClicked($event)" [ngClass]="{filters:filters}"></div>
          </div>
        }
      </div>
      @if (!showHeaderSection()) {
        <div>
          @if (sortColumnName(true)) {
            <div class="toucharea nomax" [tabindex]="tabIndex" (click)="sortClicked($event)" (keydown.space)="sortClicked($event)" id="edx_hdr_sort_column">
              <div class="toucharea-inner">
                @if (sortColumnName(false)) {
                  <div class="icon arrow" [ngClass]="{reverse:sortIsReverse()}"></div>
                }
                <div class="textheader">{{sortColumnName(true)}}</div>
              </div>
            </div>
          }
          @if (!searchCriteria) {
            <edx-refresher id="edx-list-refresh" class="refresher" [ngClass]="{filters:showFilterIcon()}" (refresh)="refreshList()" [name]="reloadStr" [dark]="isAddin" [mini]="true"></edx-refresher>
          }
          @if (!hasFootprint && sortColumnName(true) && showMenuIcons()) {
            <edx-menu [menuID]="31" [callback]="parent" [forceMenuButton]="true" class="inline sortcol" [id]="'edx_sort_column'"></edx-menu>
          }
          @if (showListViewButton()) {
            <edx-menu [menuID]="listViewMenuId" [callback]="this" class="inline right gear" [forceMenuButton]="true" [id]="'edx_list_view'"></edx-menu>
          }
          @if (!hasFootprint && showColumnChooser() && showMenuIcons()) {
            <edx-menu [menuID]="16" [callback]="parent" [forceMenuButton]="true" class="inline right gear" [id]="'edx_settings'"></edx-menu>
          }
          @if (!hasFootprint && showConfigRed() && showMenuIcons()) {
            <edx-menu [menuID]="42" [callback]="parent" [forceMenuButton]="true" class="inline right gear" [id]="'edx_configure_red'"></edx-menu>
          }
        </div>
      }
      @if (showHeaderSection()) {
        <div>
          <div class="toucharea" (click)="cancelSelect($event)" id="edx_hdr_btn_selectcancel">
            <div class="toucharea-inner">
              <div class="textheader" [tabindex]="tabIndex" (keydown.space)="cancelSelect($event)">{{this.localizer.getTranslation('FORMS.BUTTONS.CANCEL')}}</div>
            </div>
          </div>
          <div class="textheader center">{{formatNumberSelected()}}</div>
          <div class="toucharea right" (click)="selectUnselectAll()" id="edx_hdr_btn_selectclear">
            <div class="toucharea-inner">
              <div class="textheader" [tabindex]="tabIndex" (keydown.space)="selectUnselectAll()">{{selectUnselectAllText}}</div>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (filters || searchCriteria) {
    <div class="filtered-header">
      <div class="toucharea">
        <div class="toucharea-inner">
          <div class="filters">{{filters || searchCriteria}}</div>
        </div>
      </div>
      @if (filters) {
        <div class="toucharea right" (click)="clearFilter($event)" id="edx_hdr_btn_filterclear" [title]="this.localizer.getTranslation('REFINE_SEARCH.CLEAR')">
          <div class="toucharea-inner">
            <div class="filters" [tabindex]="tabIndex" (keydown.space)="clearFilter($event)">{{this.localizer.getTranslation('REFINE_SEARCH.CLEAR')}}</div>
          </div>
        </div>
      }
    </div>
  }
  @if (infoMessage) {
    <div class="item info-message">{{infoMessage}}</div>
  }
  @if (isMultiselectItem() && !!selectedLookupValues && selectedLookupValues.length) {
    <div class="chicklets">
      @for (chicklet of selectedLookupValues.split('|'); track chicklet) {
        <div class="chicklet">
          <span class="del" [tabindex]="tabIndex" (click)="removeUnselectedLookupValue(chicklet, true)" (keydown.space)="removeUnselectedLookupValue(chicklet, true)"></span>
          <span class="celltext">{{chicklet}}</span>
        </div>
      }
    </div>
  }
  <div #listContainer class="listcontainer" tabindex="0" [ngClass]="{ios:iOS, filters:filters || searchCriteria, schemalayout:useSchemaCols()}" (scroll)="scrollList($event, listContainer)" id="edx_mobile_list_container" (keydown)="onKeyDown($event)">
    @if (!reloading && !hitPreviewShown && (!getList() || !getList().length)) {
      <div><div class="item nohits">{{noHits}}</div></div>
    }
    @for (item of getList(); track item; let i = $index) {
      <div [id]="'edx_li_'+i" class="item" role="row" [ngClass]="{selected:selections.indexOf(item)>=0, dropfolder:dropFolder(item), dragover:dragOverItem===item, folder:renderItemAsFolder(item), bb:!hasPreview(item), threerows:hasThirdRow(item), oneline:isOneLine(), securityWithFullName:securityFullName && schemaId === 'SECURITY'}" (mouseover)="isAddin?enableHoverMenu(i):undefined" (mouseleave)="isAddin?disableHoverMenu(i):undefined"
        (click)="onSelectorClick(item, $event)" (keydown.space)="selectorClick(item, $event)" (dblclick)="listItemDblClick(item, $event)" [attr.aria-label]= "getLabel(item)" tabindex="0">
        @if (hasSelectCheckboxes()) {
          <div class="selector" role="checkbox" [ngClass]="{related:schemaId==='RELATED', disabled:!canSelectItem(item)}" [tabindex]="disableSecurity ? -1 :tabIndex" (click)="selectorClick(item, $event)" (keydown.space)="selectorClick(item, $event)" (dblclick)="preventEventBubbling($event)" [id]="getRowSelectorId(i)" [attr.aria-label]="altLabels['rowSelector']" [attr.aria-checked]="selections.indexOf(item)>=0"></div>
        }
        @if (schemaId==='RELATED') {
          <div class="iconwrapper related" [ngClass]="{edx_circle:isSelectMode()&&!isAddin, indent:isSelectMode()&&!isAddin}">
            <img class="icon" [ngClass]="{indent:isSelectMode() &&!isAddin && selections.indexOf(item)===-1}" src="{{getIconSrc(item)}}" alt="{{formatTypeText(item)}}">
            @if (displayTopMiniStatus(item)) {
              <img class="overlaystatusicon top" src="{{formatTopStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
            }
            @if (displaySecondMiniStatus(item)) {
              <img class="overlaystatusicon top right" src="{{formatSecondStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
            }
          </div>
        }
        @if (showIconWrapper(item)) {
          <div class="iconwrapper" [ngClass]="{edx_circle:isSelectMode()&&!isAddin, indent:isSelectMode()&&!isAddin, edx_hidden:!canSelectItem(item)&&isSelectMode()&&!isAddin}">
            @if (showIcon(item) && schemaId!=='VERSIONS') {
              <img class="icon" [ngClass]="{indent:isSelectMode() &&!isAddin && selections.indexOf(item)===-1}" src="{{getIconSrc(item)}}" alt="{{formatTypeText(item)}}">
              @if (displayStatusIcon(item)) {
                <img class="overlaystatusicon" src="{{formatStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
              }
              @if (displaySecondMiniStatus(item)) {
                <img class="overlaystatusicon top right" src="{{formatSecondStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
              }
              @if (displayTopMiniStatus(item)) {
                <img class="overlaystatusicon top" src="{{formatTopStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
              }
            }
            @if (showIcon(item) && schemaId==='VERSIONS') {
              <div class="icontext">{{item['VERSION_LABEL']}}</div>
              <img class="icon versions" [ngClass]="{indent:isSelectMode() &&!isAddin && selections.indexOf(item)===-1}" src="{{getIconSrc(item)}}" alt="{{formatTypeText(item)}}">
              @if (displayStatusIcon(item)) {
                <img class="overlaystatusicon" src="{{formatStatusIcon(item)}}" alt="{{formatStatusText(item)}}">
              }
            }
          </div>
        }
        @if (renderItemWithSchema(item)) {
          <div class="schemawrapper" [tabindex]="tabIndex" (focus)="isAddin?enableHoverMenu(i):undefined" (click)="itemClicked(item, $event)" (keyup.enter)="itemClicked(item, $event)" (keydown.space)="itemClicked(item, $event)">
            @for (col of schema.columns; track col; let j = $index) {
              <div class="schemarow">
                @if (showColForItem(col, item)) {
                  <div class="label">{{col.label}}</div>
                  <span>
                    @switch (col.format) {
                      @case (2) {
                        <div class="name" [title]="formatString(item,col.property,col.displayMap)">{{formatString(item,col.property,col.displayMap)}}</div>
                      }
                      @case (3) {
                        <div class="name">{{formatDate(item, col.property)}}</div>
                      }
                      @case (5) {
                        <div class="name">{{formatStatusText(item)}}</div>
                      }
                      @case (7) {
                        <div class="name">{{formatPath(item[col.property])}}</div>
                      }
                      @case (9) {
                        <div class="name">{{formatAction(item)}}</div>
                      }
                      @case (12) {
                        <div class="name">{{formatEnum(item,col.property,j)}}</div>
                      }
                      @case (13) {
                        <img class="image" src="listitem[col.property]">
                      }
                      @case (14) {
                        <div class="selector schemacb" [ngClass]="{on:!!item[col.property], readonly:col.readonly||isReadonly(i,col.property)}" [tabindex]="(col.readonly||isReadonly(i,col.property))?-1:tabIndex" (click)="checkboxClick(item,col.property,$event)" (keydown.space)="checkboxClick(item,col.property,$event)"></div>
                      }
                      @case (15) {
                        <div class="name">{{formatDate(item, col.property, true)}}</div>
                      }
                      @default {
                        <div class="name">{{formatString(item,col.property,col.displayMap)}}</div>
                      }
                    }
                  </span>
                }
              </div>
            }
            @if (showExtrasRow(item)) {
              <div class="schemarow">
                <div class="label">{{labelExtrasRow(item)}}</div>
                <div class="name">{{formatExtrasRow(item)}}</div>
              </div>
            }
          </div>
        }
        @if (!renderItemWithSchema(item)) {
          @if (showCheckboxForListItem(item)) {
            <div class="selector" (click)="selectorClick(item, $event)"></div>
          }
          @if (schemaId==='WHERE_USED') {
            <div class="iconwrapper" [ngClass]="{edx_circle:showIconWrapperSelector(item), indent:showIconWrapperSelector(item)}">
              @if (!showIconWrapperSelector(item)) {
                <img class="icon" src="{{getIconSrc(item)}}" alt="{{formatTypeText(item)}}">
              }
            </div>
          }
          <div class="textwrapper" [ngClass]="{oneline:isOneLine(),versions:schemaId==='VERSIONS'}" [tabindex]="tabIndex" (focus)="isAddin?enableHoverMenu(i):undefined" (click)="itemClicked(item, $event)" (keyup.enter)="itemClicked(item, $event)" (keydown.space)="itemClicked(item, $event)">
            @if (schemaId!=='SECURITY') {
              <div class="name" title={{getDetails(item)}}>{{getDetails(item)}}</div>
              <div class="inline other" [ngClass]="{extendWidth: !getOther2(item)}">{{getOther1(item)}}</div>
              @if (!!getOther2(item)) {
                @if (!isOneLine() && !!getOther1(item)) {
                  <div class="inline bullet">•</div>
                }
                <div class="inline other">{{getOther2(item)}}</div>
                <div></div>
              }
              @if (hasThirdRow(item)) {
                <div class="inline other">{{getOther3(item)}}</div>
                @if (!!getOther4(item)) {
                  @if (!tablet && !!getOther3(item)) {
                    <div class="inline bullet">•</div>
                  }
                  <div class="inline other">{{getOther4(item)}}</div>
                }
              }
            }
            @if (schemaId==='SECURITY') {
              <div class="name inline security" [ngClass]="{ios:iOS}">{{getDetails(item)}}</div>
              <div class="select-wrapper" [ngClass]="{oneline:isOneLine()}">
                <edx-select [id]="'edx_access_right'" [data]="i" [items]="rightsValues" [value]="setDisplayAccessLevel(item['rights'])" (change)="setTemplatedRights($event, i)" [disabled]="isReadonly(i,'rights') || disableSecurity" [inAccessRights]="true"></edx-select>
              </div>
              @if (securityFullName) {
                <div class="schemarow expandedrow">
                  <div class="fullname inline security expandedlabel">{{getFullNameLabel(item)}}</div>
                  <div class="fullname-wrapper" [title]="getFullName(item)" >{{getFullName(item)}}</div>
                </div>
              }
            }
          </div>
        }
        @if (showFavoriteIcon(item)) {
          <div class="favoriteWrapper iconwrapper">
            <div [tabindex]="tabIndex" class="icon" [ngClass]="{favoriteIcon: IsFavoriteItem(item), notFavoriteIcon: !IsFavoriteItem(item)}"
              [title]="getFavoriteImageToolTip(item)" (click)="itemClicked(item, $event, 'is_favorite')"
              (dblclick)="preventEventBubbling($event)"
              role="button"
              (keyup.enter)="itemClicked(item, $event, 'is_favorite')"
              (keydown.space)="itemClicked(item, $event, 'is_favorite')">
            </div>
          </div>
        }
        @if (inlineActionMenuId!==-1) {
          <edx-inline-action-bar [resid]="inlineActionMenuId" [shown]="item===hoverListItem" [listItem]="item" [target]="inlineActionTarget"></edx-inline-action-bar>
        }
      </div>
      @if (hasPreview(item)) {
        <div class="hitpreview" [tabindex]="tabIndex" (keydown.space)="itemClicked(item, $event)" (click)="itemClicked(item, $event)">
          <edx-list-item-preview [desc]="item"></edx-list-item-preview>
        </div>
      }
    }
  </div>
</div>
@if (hitPreviewShown) {
  <div class="hitpreviewpopup" [ngClass]="{shown: hitPreviewShown, hiding: hitPreviewHiding, showing: hitPreviewShowing}" (animationend)="hitPreviewAnimationComplete()">
    <div class="hitpreviewheader">
      <div class="hitpreviewtitle">
        {{hitPreviewData?hitPreviewData.DOCNAME:""}}
        <div class="rowicon close" [tabindex]="tabIndex" (click)="hitPreviewLeave($event)" (keydown.space)="hitPreviewLeave($event)"></div>
      </div>
      <div class="hitpreviewpager">
        <span>{{hitPreviewData?this.localizer.getTranslation('PAGINATOR.OF_PAGES',[hitPreviewData.page,hitPreviewData.totalpages]):""}}</span>
        <div class="hitpreviewbuttons">
          <div class="rowicon prev" [tabindex]="tabIndex" (click)="showHitPreview(null, -1)" (keydown.space)="showHitPreview(null, -1)"></div>
          <div class="rowicon next" [tabindex]="tabIndex" (click)="showHitPreview(null, 1)" (keydown.space)="showHitPreview(null, 1)"></div>
        </div>
      </div>
    </div>
    <div class="hitpreviewcontainer" [tabindex]="tabIndex">
      <div class="hitpreviewbody">
        @if (hitPreviewLoading) {
          <edx-spinner></edx-spinner>
        }
        @if (hitPreviewData) {
          <edx-list-item-preview [data]="hitPreviewData.runs"></edx-list-item-preview>
        }
      </div>
    </div>
  </div>
}
@if (!!customSecurityItem) {
  <edx-popup #pickerPopup [callback]="this" [title]="this.localizer.getTranslation('SECURITY.LEVELS.CUSTOM')" [okDisabled]="false">
    <edx-custom-security [desc]="desc" [listItem]="customSecurityItem" (customSecurityChange)="customSecurityChange($event)"></edx-custom-security>
  </edx-popup>
}
@if (reloading) {
  <edx-spinner></edx-spinner>
}
